import FiftyFiftyBanner from "@vfuk/core-fifty-fifty-banner";

interface CarouselBannerProps {
  src: string;
  headingText: string;
  primaryButtonText: string;
  primaryButtonHref: string;
}

const CarouselBanner = (props: CarouselBannerProps) => {
  const { src, headingText, primaryButtonHref, primaryButtonText } = props;

  return (
    <FiftyFiftyBanner
      appearance="primary"
      heading={{
        text: headingText,
        level: 4,
      }}
      primaryButton={{
        text: primaryButtonText,
        href: primaryButtonHref,
      }}
      backgroundImage={{
        sm: {
          src: src,
        },
      }}
    />
  );
};

export default CarouselBanner;
